// Brand logo — uses the official Guiding Support Services artwork provided
// by the client. The image already contains the wordmark on a navy square, so
// it is used as-is without any extra label alongside it.

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ndis-provider-hub-2/artifacts/eu2teg8f_FullLogowebsite.jpg";

export default function Logo({ className = "", size = 56 }) {
  return (
    <img
      src={LOGO_URL}
      alt="Guiding Support Services"
      width={size}
      height={size}
      className={`rounded-xl object-cover shadow-sm ${className}`.trim()}
      style={{ height: size, width: size }}
      loading="eager"
    />
  );
}
